import _ from 'lodash'

export const getAllSectors = (state) => {
    return state.sectors
}

export const getAllCategory = (state) => {
    return state.category
}

export const getAllSubCategory = (state) => {
    return state.sub_category
}

export const getAllSubSubCategory = (state) => {
    return state.sub_sub_category
}

export const getSecPred = (state) => {
    return state.sec_pred
}

export const getCatPred = (state) => {
    return state.cat_pred
}

export const getMailingTypePred = (state) => {
    return state.mailing_type_pred
}

export const getSecComPred = (state) => {
    return state.sec_company_pred
}

export const getAllCardTypes = (state) => {
    var arr = new Array()
    arr.push({ text: 'Select One', value: '' })
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.card_type, function (o) {
        arr.push({ text: o.CardTypeName, value: o.CardTypeID })
    })
    return arr
}
export const getAllCardTypesMultiple = (state) => {
    var arr = new Array()
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.card_type, function (o) {
        arr.push({ text: o.CardTypeName, value: o.CardTypeID })
    })
    return arr
}

export const getVarientAllType = (state) => {
    var arr = new Array()
    if (typeof state.raw_data.varient_type !== 'undefined') {
        state.raw_data.varient_type.forEach(function (o) {
            arr.push({ text: o.vname, value: o.vid })
        })
    }
    return arr
}

export const getMediaChannel = (state) => {
    var arr = new Array()
    arr.push({ text: 'Select One', value: '' })
    if (state.product_raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.mediachannel, function (o) {
        arr.push({ text: o.mChannelName, value: o.mChannelID })
    })
    return arr
}

export const getAllOfferOrigin = (state) => {
    var arr = new Array()
    if (state.product_raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.offer_origin, function (o) {
        arr.push({ text: o.oo_name, value: o.oo_id })
    })
    return arr
}

export const getAllRawOfferOrigin = (state) => {
    return state.raw_data.offer_origin
}
export const getAllRawRiders = (state) => {
    return state.raw_data.riders
}
export const getAllRawCommunicationTypes = (state) => {
    return state.raw_data.communication_type
}

export const getElectronicType = (state) => {
    var arr = new Array()
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.electronic_type, function (o) {
        o.text = o.electronic_name
        o.value = o.electronic_id
        arr.push(o)
    })
    return arr
}

export const getSocialMediaAddType = (state) => {
    var arr = new Array()
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.socialmedia_adtype, function (o) {
        arr.push({ text: o.text_value, value: o.id })
    })
    return arr
}

export const getAudience = (state) => {
    var arr = new Array()
    arr.push({ text: 'Select One', value: '' })
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.audience, function (o) {
        arr.push({ text: o.mPanelName, value: o.mPanelID })
    })
    return arr
}

export const getAllIssues = (state) => {
    var arr = new Array()
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.issue, function (o) {
        arr.push({ text: o.IssueTypeName, value: o.IssueTypeID })
    })
    return arr
}

export const getAllAncilaryProducts = (state) => {
    var arr = new Array()
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.ancillary_product, function (o) {
        arr.push({ text: o.ancillary_name, value: o.ancillary_id })
    })
    return arr
}

export const getAllRawGroupSize = (state) => {
    return state.raw_data.group_size
}

export const getAllGroupSize = (state) => {
    var arr = new Array()
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.group_size, function (o) {
        arr.push({ text: o.name, value: o.id })
    })
    return arr
}

export const getAllFaceAmount = (state) => {
    return state.raw_data.faceamount
}

export const getAllTermLength = (state) => {
    return state.raw_data.product_term_length
}

export const getAllIssueTypes = (state) => {
    return state.raw_data.issue
}

export const getAllBusinessContent = (state) => {
    var arr = new Array()
    //arr.push({text:'Select One',value:0})
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.business_content, function (o) {
        arr.push({ text: o.text_value, value: o.key_id })
    })
    return arr
}

export const getAllMailingType = (state) => {
    var arr = new Array()
    arr.push({ text: 'Select One', value: '' })
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.mailing_type, function (o) {
        o.text = o.mTypeName
        o.value = o.mTypeID
        arr.push(o)
    })
    return arr
}

export const getAllCampaignLanguage = (state) => {
    var arr = new Array()
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.campaign_language, function (o) {
        o.text = o.text_value
        o.value = o.id
        arr.push(o)
    })
    return arr
}

export const getAllTargetMarket = (state) => {
    var arr = new Array()
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.target_market, function (o) {
        o.text = o.tm_name
        o.value = o.tm_id
        arr.push(o)
    })
    return arr
}

export const getRawProductStates = (state) => {
    var arr = new Array()
    if (state.raw_data === '') {
        return arr
    }
    return state.raw_data.states
}

export const getProductStates = (state) => {
    var arr = new Array()
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.states, function (o) {
        o.text = o.stateName
        o.value = o.stateID
        arr.push(o)
    })
    return arr
}

export const getAllPrimaryCountry = (state) => {
    var arr = new Array()
    arr.push({ text: 'Select One', value: '' })
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.primary_country, function (o) {
        arr.push({ text: o.countryName, value: o.countryCode })
    })
    return arr
}

export const getAllRawAgeProduct = (state) => {
    var arr = new Array()
    if (state.raw_data === '') {
        return arr
    }
    return state.raw_data.age_product
}

export const getAllAgeProduct = (state) => {
    var arr = new Array()
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.age_product, function (o) {
        arr.push({ text: o.age_pname, value: o.age_pID })
    })
    return arr
}

export const getAllRawIncomeType = (state) => {
    var arr = new Array()
    if (state.raw_data === '') {
        return arr
    }
    return state.raw_data.incometype
}

export const getAllIncomeType = (state) => {
    var arr = new Array()
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.incometype, function (o) {
        arr.push({ text: o.incomeName, value: o.incomeID })
    })
    return arr
}

export const getAllRawCommType = (state) => {
    return state.raw_data.communication_type
}

export const getAllCommType = (state) => {
    var arr = new Array()
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.communication_type, function (o) {
        arr.push({ text: o.type, value: o.ID })
    })
    return arr
}

export const getAllSignOnIncentiveData = (state) => {
    var arr = new Array()
    arr.push({ text: 'Select One', value: 0 })
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.sign_on_incentive_type, function (o) {
        arr.push({ text: o.key_id, value: o.id })
    })
    return arr
}

export const getAllSignOnAcceleratorType = (state) => {
    var arr = new Array()
    arr.push({ text: 'Select One', value: 0 })
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.sign_on_accelerator_type, function (o) {
        arr.push({ text: o.text_value, value: o.id })
    })
    return arr
}

export const getAllResponseType = (state) => {
    var arr = new Array()
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.response_machanism, function (o) {
        arr.push({ text: o.responseMechName, value: o.responseMechID })
    })
    return arr
}

export const getAllDeliveryType = (state) => {
    var arr = new Array()
    arr.push({ text: 'Select One', value: '' })
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.delivery_method, function (o) {
        arr.push({ text: o.delmethname, value: o.delmethid })
    })
    return arr
}

// Data
export const getPrimaryCountry = (state) => {
    return state.data.primary_country
}

export const getSubmitData = (state) => {
    return state.data
}

export const getEntryDate = (state) => {
    return state.data.entrydate
}

export const getFauxCheck = (state) => {
    return state.data.faux_check
}

export const getTipOnCard = (state) => {
    return state.data.tip_on_card;
  };
  
export const getHandwriting = (state) => {
    return state.data.handwriting;
  };

export const getFeeProduct = (state) => {
    return state.data.fee_product
}

export const getPerscription = (state) => {
    return state.data.prescription
}

export const getIsHphsa = (state) => {
    return state.data.is_hphsa
}

export const getGender = (state) => {
    return state.data.gender
}

export const getCiti = (state) => {
    return state.data.citi
}

export const getIsMobile = (state) => {
    return state.data.ismobile
}

export const getIsPrescreen = (state) => {
    return state.data.isprescreen
}

export const getStateSpecific = (state) => {
    return state.data.state_specific
}

export const getOfferExpiry = (state) => {
    return state.data.offer_expiry_date
}

export const getPersonalization = (state) => {
    return state.data.personalization
}

export const getProductHeadline = (state) => {
    return state.data.product_headline
}

export const getProductName = (state) => {
    return state.data.product_name
}

export const getWorksiteVoluntary = (state) => {
    return state.data.worktype_voluntary
}

export const getCommunicationType = (state) => {
    return state.data.communication_type
}

export const getOfferOrigin = (state) => {
    return state.data.offer_origin
}

export const getStateProvince = (state) => {
    return state.data.state_province
}

export const getStateAudience = (state) => {
    return state.data.audience
}

export const getStateMediaChannel = (state) => {
    return state.data.media_chan
}

export const getMailingType = (state) => {
    return state.data.mailing_type
}

export const getCampaignLang = (state) => {
    return state.data.campaign_language
}

export const getBusinessContent = (state) => {
    return state.data.business_content
}

export const getAffinity = (state) => {
    return state.data.affinity
}

export const getCompanies = (state) => {
    return state.data.companies
}

export const getResponseMechanism = (state) => {
    return state.data.response_mechanism
}

export const getAncillaryProducts = (state) => {
    return state.data.ancilary_products
}

export const getTargetMarket = (state) => {
    return state.data.target_market
}

export const getVarientEntryId = (state) => {
    return state.data.varient_entry_id
}

export const getVariantType = (state) => {
    return state.data.varient_type
}

export const getSector = (state) => {
    return state.sectorsData
}

export const getSubmittableSectors = (state) => {
    return state.data.sectors
}

// export const getSelectedCategory = (state) => {
//     return state.data.category
// }

// export const getSelectedSubCategory = (state) => {
//     return state.data.subcategory
// }

// export const getSelectedSubSubCategory = (state) => {
//     return state.data.subsubcategory
// }

export const getProductAge = (state) => {
    return state.data.age
}

export const getProductIncome = (state) => {
    return state.data.income
}

export const getPanelists = (state) => {
    return state.data.panelists
}

export const getSignOn1Incentive = (state) => {
    return state.data.sign_on_1.sign_on_incentive
}

export const getSignOn2Incentive = (state) => {
    return state.data.sign_on_2.sign_on_incentive
}

export const getSignOn3Incentive = (state) => {
    return state.data.sign_on_3.sign_on_incentive
}

export const getSignOn1AcceleretorPer = (state) => {
    return state.data.sign_on_1.sign_on_acceleretor_per
}

export const getSignOn2AcceleretorPer = (state) => {
    return state.data.sign_on_2.sign_on_acceleretor_per
}

export const getSignOn3AcceleretorPer = (state) => {
    return state.data.sign_on_3.sign_on_acceleretor_per
}

export const getSignOn1AcceleretorType = (state) => {
    return state.data.sign_on_1.sign_on_acceleretor_type
}

export const getSignOn2AcceleretorType = (state) => {
    return state.data.sign_on_2.sign_on_acceleretor_type
}

export const getSignOn3AcceleretorType = (state) => {
    return state.data.sign_on_3.sign_on_acceleretor_type
}

export const getSignOn1LimitSpecificCategory = (state) => {
    return state.data.sign_on_1.sign_on_limit_specific_category
}

export const getSignOn2LimitSpecificCategory = (state) => {
    return state.data.sign_on_2.sign_on_limit_specific_category
}

export const getSignOn3LimitSpecificCategory = (state) => {
    return state.data.sign_on_3.sign_on_limit_specific_category
}

export const getSignOn1FixedDate = (state) => {
    return state.data.sign_on_1.sign_on_fixed_date
}

export const getSignOn2FixedDate = (state) => {
    return state.data.sign_on_2.sign_on_fixed_date
}

export const getSignOn3FixedDate = (state) => {
    return state.data.sign_on_3.sign_on_fixed_date
}

export const getSignOn1IncentiveType = (state) => {
    return state.data.sign_on_1.sign_on_incentive_type
}

export const getSignOn1IncentiveValue = (state) => {
    return state.data.sign_on_1.sign_on_incentive_value
}

export const getSignOn2IncentiveValue = (state) => {
    return state.data.sign_on_2.sign_on_incentive_value
}

export const getSignOn3IncentiveValue = (state) => {
    return state.data.sign_on_3.sign_on_incentive_value
}

export const getSignOn1MaxAward = (state) => {
    return state.data.sign_on_1.sign_on_max_award
}

export const getSignOn2MaxAward = (state) => {
    return state.data.sign_on_2.sign_on_max_award
}

export const getSignOn3MaxAward = (state) => {
    return state.data.sign_on_3.sign_on_max_award
}

export const getSignOn1IncentiveMaxSpend = (state) => {
    return state.data.sign_on_1.sign_on_incentive_max_spend
}

export const getSignOn2IncentiveMaxSpend = (state) => {
    return state.data.sign_on_2.sign_on_incentive_max_spend
}

export const getSignOn3IncentiveMaxSpend = (state) => {
    return state.data.sign_on_3.sign_on_incentive_max_spend
}

export const getSignOn1IncentiveMinSpend = (state) => {
    return state.data.sign_on_1.sign_on_incentive_min_spend
}

export const getSignOn2IncentiveMinSpend = (state) => {
    return state.data.sign_on_2.sign_on_incentive_min_spend
}

export const getSignOn3IncentiveMinSpend = (state) => {
    return state.data.sign_on_3.sign_on_incentive_min_spend
}

export const getSignOn1IncentiveWindowMonth = (state) => {
    return state.data.sign_on_1.sign_on_incentive_window_month
}

export const getSignOn2IncentiveWindowMonth = (state) => {
    return state.data.sign_on_2.sign_on_incentive_window_month
}

export const getSignOn3IncentiveWindowMonth = (state) => {
    return state.data.sign_on_3.sign_on_incentive_window_month
}

export const getSignOn2IncentiveType = (state) => {
    return state.data.sign_on_2.sign_on_incentive_type
}

export const getSignOn3IncentiveType = (state) => {
    return state.data.sign_on_3.sign_on_incentive_type
}

//mortgage
export const getRefinance = (state) => {
    return state.data.mortgage_loans.refinance
}
export const get_jumbo_non_conforming = (state) => {
    return state.data.mortgage_loans.jumbo_non_conforming
}
export const get_va = (state) => {
    return state.data.mortgage_loans.va
}
export const get_fha = (state) => {
    return state.data.mortgage_loans.fha
}
export const get_conventional = (state) => {
    return state.data.mortgage_loans.conventional
}
export const get_usda = (state) => {
    return state.data.mortgage_loans.usda
}
export const get_correspondent_lending = (state) => {
    return state.data.mortgage_loans.correspondent_lending
}
export const get_application_type = (state) => {
    return state.data.mortgage_loans.application_type
}
export const get_mortgage_loan_regular_pricing_details = (state) => {
    return state.data.mortgage_loans.mortgage_loan_regular_pricing_details
}
export const get_offered_loan_amount = (state) => {
    return state.data.mortgage_loans.offered_loan_amount
}
export const get_maximum_loan_amount = (state) => {
    return state.data.mortgage_loans.maximum_loan_amount
}
export const get_minimum_loan_amount = (state) => {
    return state.data.mortgage_loans.minimum_loan_amount
}
export const get_loan_term_months = (state) => {
    return state.data.mortgage_loans.loan_term_months
}
export const get_offered_apr = (state) => {
    return state.data.mortgage_loans.offered_apr
}
export const get_upper_apr = (state) => {
    return state.data.mortgage_loans.upper_apr
}
export const get_lower_apr = (state) => {
    return state.data.mortgage_loans.lower_apr
}
export const get_rate_type = (state) => {
    return state.data.mortgage_loans.rate_type
}
export const get_mortgage_loan_introductory_pricing_details = (state) => {
    return state.data.mortgage_loans.mortgage_loan_introductory_pricing_details
}
export const get_introductory_apr = (state) => {
    return state.data.mortgage_loans.introductory_apr
}
export const get_introductory_period_months = (state) => {
    return state.data.mortgage_loans.introductory_period_months
}

//travel and leisure
export const get_travel_debit_card_mentioned = (state) => {
    return state.data.travel.debit_card_mentioned
}
export const get_travel_credit_card_mentioned = (state) => {
    return state.data.travel.credit_card_mentioned
}
export const get_travel_credit_network = (state) => {
    return state.data.travel.credit_network
}

//retail

export const get_retail_credit_card_mentioned = (state) => {
    return state.data.retail.credit_card_mentioned
}

// payment card
export const getPaymentCardAnnualFeeDetails = (state) => {
    return state.data.payment_card.annual_fee_details
}
export const getPaymentCardApplicationType = (state) => {
    return state.data.payment_card.application_type
}
export const getPaymentCardBalanceTransferIntroductoryApr = (state) => {
    return state.data.payment_card.balance_transfer_introductory_apr
}
export const getPaymentCardBalanceTransferIntroductoryFeeDetails = (state) => {
    return state.data.payment_card.balance_transfer_introductory_fee_details
}
export const getPaymentCardBalanceTransferIntroductoryFeePeriodMonths = (state) => {
    return state.data.payment_card.balance_transfer_introductory_fee_period_months
}
export const getPaymentCardBalanceTransferIntroductoryMaximumFee = (state) => {
    return state.data.payment_card.balance_transfer_introductory_maximum_fee
}
export const getPaymentCardBalanceTransferIntroductoryMinimumFee = (state) => {
    return state.data.payment_card.balance_transfer_introductory_minimum_fee
}
export const getPaymentCardBalanceTransferIntroductoryPeriodMonths = (state) => {
    return state.data.payment_card.balance_transfer_introductory_period_months
}
export const getPaymentCardBalanceTransferIntroductoryUsageFee = (state) => {
    return state.data.payment_card.balance_transfer_introductory_usage_fee
}

export const getPaymentTier2CardBalanceTransferIntroductoryUsageFee = (state) => {
    return state.data.payment_card.tier_2_balance_transfer_introductory_usage_fee
}
export const getPaymentCardBalanceTransferMaximunFee = (state) => {
    return state.data.payment_card.balance_transfer_maximun_fee
}
export const getPaymentCardBalanceTransferMinimumFee = (state) => {
    return state.data.payment_card.balance_transfer_minimum_fee
}
export const getPaymentCardTier2BalanceTransferMinimumFee = (state) => {
    return state.data.payment_card.tier_2_balance_transfer_minimum_fee
}
export const getPaymentCardBalanceTransferRegularAprDetail = (state) => {
    return state.data.payment_card.balance_transfer_regular_apr_detail
}
export const getPaymentCardBalanceTransferRegularRateType = (state) => {
    return state.data.payment_card.balance_transfer_regular_rate_type
}
export const getPaymentCardBalanceTransferUsageFee = (state) => {
    return state.data.payment_card.balance_transfer_usage_fee
}
export const getPaymentCardCardNetwork = (state) => {
    return state.data.payment_card.card_network
}
export const getPaymentCardCashAdvanceIntroductoryApr = (state) => {
    return state.data.payment_card.cash_advance_introductory_apr
}
export const getPaymentCardCashAdvanceIntroductoryFeeDetails = (state) => {
    return state.data.payment_card.cash_advance_introductory_fee_details
}
export const getPaymentCardCashAdvanceIntroductoryFeePeriodMonths = (state) => {
    return state.data.payment_card.cash_advance_introductory_fee_period_months
}
export const getPaymentCardCashAdvanceIntroductoryMaximumFee = (state) => {
    return state.data.payment_card.cash_advance_introductory_maximum_fee
}
export const getPaymentCardCashAdvanceIntroductoryMinimumFee = (state) => {
    return state.data.payment_card.cash_advance_introductory_minimum_fee
}
export const getPaymentCardCashAdvanceIntroductoryPeriodMonths = (state) => {
    return state.data.payment_card.cash_advance_introductory_period_months
}
export const getPaymentCardCashAdvanceIntroductoryUsageFee = (state) => {
    return state.data.payment_card.cash_advance_introductory_usage_fee
}
export const getPaymentCardCashAdvanceMaximumFee = (state) => {
    return state.data.payment_card.cash_advance_maximum_fee
}
export const getPaymentCardCashAdvanceMinimumFee = (state) => {
    return state.data.payment_card.cash_advance_minimum_fee
}
export const getPaymentCardCashAdvanceUsageFee = (state) => {
    return state.data.payment_card.cash_advance_usage_fee
}
export const getPaymentCardLateFeeDetails = (state) => {
    return state.data.payment_card.late_fee_details
}
export const getPaymentCardMaximumCardLimit = (state) => {
    return state.data.payment_card.maximum_card_limit
}
export const getPaymentCardMonthlyMaintenanceFee = (state) => {
    return state.data.payment_card.MonthlyMaintenanceFee
}
export const getPaymentCardStandardMonthlyMaintenanceFee = (state) => {
    return state.data.payment_card.StandardMonthlyMaintenanceFee
}
export const getPaymentCardMinimumCardLimit = (state) => {
    return state.data.payment_card.minimum_card_limit
}
export const getPaymentCardOverlimitFeeDetails = (state) => {
    return state.data.payment_card.overlimit_fee_details
}
export const getPaymentCardPerchaseRegularRateType = (state) => {
    return state.data.payment_card.perchase_regular_rate_type
}
export const getPaymentCardPrimaryCardLevel = (state) => {
    return state.data.payment_card.primary_card_level
}
export const getPaymentCardProductID = (state) => {
    return state.data.payment_card.product_id
}
export const getPaymentCardPurchaseIntroductoryApr = (state) => {
    return state.data.payment_card.purchase_introductory_apr
}
export const getPaymentCardPurchaseIntroductoryPeriodMonths = (state) => {
    return state.data.payment_card.purchase_introductory_period_months
}
export const getPaymentCardPurchaseRegularAprDetail = (state) => {
    return state.data.payment_card.purchase_regular_apr_detail
}
export const getPaymentCardReloadable = (state) => {
    return state.data.payment_card.reloadable
}
export const getPaymentCardRewardProgram = (state) => {
    return state.data.payment_card.reward_program
}
export const getPaymentCardRewardProgramEmphasis = (state) => {
    return state.data.payment_card.reward_program_emphasis
}
export const getPaymentCardRewardProgramRate = (state) => {
    return state.data.payment_card.reward_program_rate
}
export const getPaymentCardSecondaryCardLevel = (state) => {
    return state.data.payment_card.secondary_card_level
}
export const getPaymentCardPenaltyApr = (state) => {
    return state.data.payment_card.PenaltyAPR
}
export const getPaymentCardPenaltyAprDetails = (state) => {
    return state.data.payment_card.PenaltyAPRDetails
}
export const getPaymentCardTier1AnnualFee = (state) => {
    return state.data.payment_card.tier_1_annual_fee
}
export const getPaymentCardTier1BalanceTransferRegularApr = (state) => {
    return state.data.payment_card.tier_1_balance_transfer_regular_apr
}
export const getPaymentCardTier1LateFee = (state) => {
    return state.data.payment_card.tier_1_late_fee
}
export const getPaymentCardTier1OverlimitFee = (state) => {
    return state.data.payment_card.tier_1_overlimit_fee
}
export const getPaymentCardTier1PurchaseRegularApr = (state) => {
    return state.data.payment_card.tier_1_purchase_regular_apr
}
export const getPaymentCardTier2AnnualFee = (state) => {
    return state.data.payment_card.tier_2_annual_fee
}
export const getPaymentCardTier2BalanceTransferRegularApr = (state) => {
    return state.data.payment_card.tier_2_balance_transfer_regular_apr
}
export const getPaymentCardTier2LateFee = (state) => {
    return state.data.payment_card.tier_2_late_fee
}
export const getPaymentCardTier2OverlimitFee = (state) => {
    return state.data.payment_card.tier_2_overlimit_fee
}
export const getPaymentCardTier2PurchaseRegularApr = (state) => {
    return state.data.payment_card.tier_2_purchase_regular_apr
}
export const getPaymentCardTier3AnnualFee = (state) => {
    return state.data.payment_card.tier_3_annual_fee
}
export const getPaymentCardTier3BalanceTransferRegularApr = (state) => {
    return state.data.payment_card.tier_3_balance_transfer_regular_apr
}
export const getPaymentCardTier3LateFee = (state) => {
    return state.data.payment_card.tier_3_late_fee
}
export const getPaymentCardTier3OverlimitFee = (state) => {
    return state.data.payment_card.tier_3_overlimit_fee
}
export const getPaymentCardTier3PurchaseRegularApr = (state) => {
    return state.data.payment_card.tier_3_purchase_regular_apr
}
export const getPaymentCardPromotionalPricingUsageOffer = (state) => {
    return state.data.payment_card.promotional_purchase_pricing_usage_offer
}
export const getPaymentCardPromotionalPricingUsageOfferMonths = (state) => {
    return state.data.payment_card.promotional_purchase_pricing_usage_offer_months
}

// TELECOMM
export const getTelecomPlanFeatured = (state) => {
    return state.data.telecom.plan_featured
}
export const getTelecomFeaturedPlanName = (state) => {
    return state.data.telecom.featured_plan_name
}
export const getTelecomContractRequired = (state) => {
    return state.data.telecom.contract_required
}
export const getTelecomInternetSpeed = (state) => {
    return state.data.telecom.internet_speed
}
export const getTelecomMonthlyCost = (state) => {
    return state.data.telecom.monthly_cost
}
export const getTelecomLowerFeaturedMonthlyCost = (state) => {
    return state.data.telecom.lower_featured_monthly_cost
}
export const getTelecomUpperFeaturedMonthlyCost = (state) => {
    return state.data.telecom.upper_featured_monthly_cost
}
export const getTelecomActivationCharge = (state) => {
    return state.data.telecom.activation_charge
}
export const getTelecomInstallationCharge = (state) => {
    return state.data.telecom.installation_charge
}
export const getTelecomLocalCallingMonthlyCharge = (state) => {
    return state.data.telecom.local_calling_monthly_charge
}
export const getTelecomLocalDistanceMonthlyCharge = (state) => {
    return state.data.telecom.local_distance_monthly_charge
}
export const getTelecomLongDistanceMonthlyCharge = (state) => {
    return state.data.telecom.long_distance_monthly_charge
}
export const getTelecomIntroductoryCost = (state) => {
    return state.data.telecom.introductory_cost
}
export const getTelecomIntroductoryPeriodMonths = (state) => {
    return state.data.telecom.introductory_period_months
}


// RETAIL
export const getRetailCreditCardMentioned = (state) => {
    return state.data.retail.credit_card_mentioned
}

// Social Media
export const getMediaChannelNumberUpdatesTweets = (state) => {
    return state.data.media_channel.number_updates_tweets
}
export const getMediaChannelNumberFansFollowers = (state) => {
    return state.data.media_channel.number_fans_followers
}
export const getMediaChannelExternalLink = (state) => {
    return state.data.media_channel.external_link
}

export const getMediaChannelElectronicType = (state) => {
    return state.data.media_channel.electronic_type
}

export const getMediaChannelSocialMediaAddType = (state) => {
    return state.data.media_channel.social_media_add_type
}

// Banking
export const getBankingRewardProgramEmphasis = (state) => {
    return state.data.banking.reward_program_emphasis
}
export const getBankingRewardProgram = (state) => {
    return state.data.banking.reward_program
}
export const getBankingCardType = (state) => {
    return state.data.banking.card_type
}
export const getBankingDebitCardMentioned = (state) => {
    return state.data.banking.debit_card_mentioned
}
export const getBankingCdApy = (state) => {
    return state.data.banking.cd_apy
}
export const getBankingCdApr = (state) => {
    return state.data.banking.cd_apr
}
export const getBankingMoneyMarketApy = (state) => {
    return state.data.banking.money_market_apy
}
export const getBankingMoneyMarketApr = (state) => {
    return state.data.banking.money_market_apr
}
export const getBankingSavingApy = (state) => {
    return state.data.banking.saving_apy
}
export const getBankingSavingApr = (state) => {
    return state.data.banking.saving_apr
}
export const getBankingCheckingApy = (state) => {
    return state.data.banking.checking_apy
}
export const getBankingCheckingApr = (state) => {
    return state.data.banking.checking_apr
}
export const getBankingFreeChecking = (state) => {
    return state.data.banking.free_checking
}
export const getBankingMinimumDeposit = (state) => {
    return state.data.banking.minimum_deposit
}

// Energy
export const getEnergyOfferPricePerKwh = (state) => {
    return state.data.energy.offer_price_per_kwh
}
export const getEnergyOfferPricePerKwh2 = (state) => {
    return state.data.energy.offer_price_per_kwh2
}
export const getEnergyOfferPricePerKwh3 = (state) => {
    return state.data.energy.offer_price_per_kwh3
}
export const getEnergyOfferPricePerKwh4 = (state) => {
    return state.data.energy.offer_price_per_kwh4
}
export const getEnergyTermLength = (state) => {
    return state.data.energy.term_length
}
export const getEnergyTermLength2 = (state) => {
    return state.data.energy.term_length2
}
export const getEnergyTermLength3 = (state) => {
    return state.data.energy.term_length3
}
export const getEnergyTermLength4 = (state) => {
    return state.data.energy.term_length4
}
export const getEnergyCancelFee = (state) => {
    return state.data.energy.cancel_fee
}
export const getEnergyCancelFeeDetails = (state) => {
    return state.data.energy.cancel_fee_details
}
export const getEnergyRateType = (state) => {
    return state.data.energy.rate_type
}
export const getEnergyRateType2 = (state) => {
    return state.data.energy.rate_type2
}
export const getEnergyRateType3 = (state) => {
    return state.data.energy.rate_type3
}
export const getEnergyRateType4 = (state) => {
    return state.data.energy.rate_type4
}

// Payment Card
export const getCreditCardPromotionalOffer = (state) => {
    return state.data.credit_card.promotional_offer
}
export const getCreditCardTier1BalanceTransferIntroductionApr = (state) => {
    return state.data.credit_card.tier_1_balance_transfer_introduction_apr
}
export const getCreditCardTier1BalanceTransferIntroductoryPeriod = (state) => {
    return state.data.credit_card.tier_1_balance_transfer_introductory_period
}
export const getCreditCardTier2BalanceTransferIntroductionApr = (state) => {
    return state.data.credit_card.tier_2_balance_transfer_introduction_apr
}
export const getCreditCardTier2BalanceTransferIntroductoryPeriod = (state) => {
    return state.data.credit_card.tier_2_balance_transfer_introductory_period
}
export const getCreditCardBalanceTransferIntroductoryUsageFee = (state) => {
    return state.data.credit_card.PromotionalOfferUsageFee
}
export const getCreditCardTier2BalanceTransferIntroductoryUsageFee = (state) => {
    return state.data.credit_card.tier_2_balance_transfer_introductory_usage_fee
}
export const getCreditCardBalanceTransferIntroductoryMinimumFee = (state) => {
    return state.data.credit_card.PromotionalOfferMinimumFee
}
export const getCreditCardTier2BalanceTransferIntroductoryMinimumFee = (state) => {
    return state.data.credit_card.tier_2_balance_transfer_introductory_minimum_fee
}

export const getCreditCardBalanceTransferIntroductoryMaximumFee = (state) => {
    return state.data.credit_card.PromotionalOfferMaximumFee
}
export const getCreditCardBalanceTransferIntroductoryFeePeriod = (state) => {
    return state.data.credit_card.balance_transfer_introductory_fee_period
}
export const getCreditCardTier1CashAdvanceIntroductoryApr = (state) => {
    return state.data.credit_card.tier_1_cash_advance_introductory_apr
}
export const getCreditCardTier1CashAdvanceIntroductoryPeriod = (state) => {
    return state.data.credit_card.tier_1_cash_advance_introductory_period
}
export const getCreditCardTier2CashAdvanceIntroductoryApr = (state) => {
    return state.data.credit_card.tier_2_cash_advance_introductory_apr
}
export const getCreditCardTier2CashAdvanceIntroductoryPeriod = (state) => {
    return state.data.credit_card.tier_2_cash_advance_introductory_period
}
export const getCreditCardCashAdvanceIntroductoryUsageFee = (state) => {
    return state.data.credit_card.cash_advance_introductory_usage_fee
}
export const getCreditCardCashAdvanceIntroductoryMinimumFee = (state) => {
    return state.data.credit_card.cash_advance_introductory_minimum_fee
}
export const getCreditCardCashAdvanceIntroductoryMaximumFee = (state) => {
    return state.data.credit_card.cash_advance_introductory_maximum_fee
}
export const getCreditCardCashAdvanceIntroductoryFeePeriod = (state) => {
    return state.data.credit_card.cash_advance_introductory_fee_period
}
export const getCreditCardTier1PurchaseIntroductoryApr = (state) => {
    return state.data.credit_card.tier_1_purchase_introductory_apr
}
export const getCreditCardTier1PurchaseIntroductoryPeriod = (state) => {
    return state.data.credit_card.tier_1_purchase_introductory_period
}
export const getCreditCardTier2PurchaseIntroductoryApr = (state) => {
    return state.data.credit_card.tier_2_purchase_introductory_apr
}
export const getCreditCardTier2PurchaseIntroductoryPeriod = (state) => {
    return state.data.credit_card.tier_2_purchase_introductory_period
}
export const getCreditCardPurchaseIntroductoryUsageFee = (state) => {
    return state.data.credit_card.purchase_introductory_usage_fee
}
export const getCreditCardPurchaseIntroductoryMinimumFee = (state) => {
    return state.data.credit_card.purchase_introductory_minimum_fee
}
export const getCreditCardPurchaseIntroductoryMaximumFee = (state) => {
    return state.data.credit_card.purchase_introductory_maximum_fee
}
export const getCreditCardPurchaseIntroductoryFeePeriod = (state) => {
    return state.data.credit_card.purchase_introductory_fee_period
}
export const getCreditCardBalanceTransferRegularApr = (state) => {
    return state.data.credit_card.balance_transfer_regular_apr
}
export const getCreditCardBalanceTransferRegularRateType = (state) => {
    return state.data.credit_card.balance_transfer_regular_rate_type
}
export const getCreditCardBalanceTransferUsageFee = (state) => {
    return state.data.credit_card.balance_transfer_usage_fee
}
export const getCreditCardBalanceTransferMinimumFee = (state) => {
    return state.data.credit_card.balance_transfer_minimum_fee
}
export const getCreditCardBalanceTransferMaximumFee = (state) => {
    return state.data.credit_card.balance_transfer_maximum_fee
}
export const getCreditCardCashAdvanceRegularApr = (state) => {
    return state.data.credit_card.cash_advance_regular_apr
}
export const getCreditCardCashAdvanceRegularRateType = (state) => {
    return state.data.credit_card.cash_advance_regular_rate_type
}
export const getCreditCardCashAdvanceUsageFee = (state) => {
    return state.data.credit_card.cash_advance_usage_fee
}
export const getCreditCardCashAdvanceMinimumFee = (state) => {
    return state.data.credit_card.cash_advance_minimum_fee
}
export const getCreditCardCashAdvanceMaximumFee = (state) => {
    return state.data.credit_card.cash_advance_maximum_fee
}
export const getCreditCardPerchaseRegularApr = (state) => {
    return state.data.credit_card.perchase_regular_apr
}
export const getCreditCardPerchaseRegularRateType = (state) => {
    return state.data.credit_card.perchase_regular_rate_type
}

export const getMediaChannelDigitalSource = (state) => {
    return state.data.media_channel.digital_source
}

export const getMuid = (state) => {
    return state.data.muid
}
export const getUserid = (state) => {
    return state.data.userid
}

export const getProductObservedTrafficSource = (state) => {
    return state.data.observed_traffic_source
}

export const getProductDmTmSource = (state) => {
    return state.data.dm_tm_source
}

export const getOngoingIncentive = (state) => {
    return state.data.sign_on_1.ongoing_incentive
}

export const getPublications = (state) => {
    return state.data.publication
}

export const getRiders = (state) => {
    return state.data.riders
}

export const getGroupSize = (state) => {
    return state.data.group_size
}

export const getFaceAmount = (state) => {
    return state.data.face_amount
}

export const getTermLength = (state) => {
    return state.data.term_length
}

export const getIssueType = (state) => {
    return state.data.issue_type
}

export const getAllPerscription = (state) => {
    return state.raw_data.prescription_sector
}

export const getAllhsaSectors = (state) => {
    return state.raw_data.hsa_sector
}

export const getFeeProductSectors = (state) => {
    return state.raw_data.feeproduct_sector
}

export const getFauxCheckSectors = (state) => {
    return state.raw_data.fauxcheck_sector
}

export const getTipOnCardSectors = (state) => {
    return state.raw_data.tip_on_card;
  };
  
export const getHandwritingSectors = (state) => {
    return state.raw_data.handwriting;
  };
  
export const getAllRiders = (state) => {
    var arr = new Array()
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.riders, function (o) {
        arr.push({ text: o.ridersName, value: o.ridersID })
    })
    return arr
}

export const getPaymentRateTypes = (state) => {
    var arr = new Array()
    arr.push({ text: 'Select One', value: '' })
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.payment_rate_type, function (o) {
        arr.push({ text: o.RateTypeName, value: o.RateTypeID })
    })
    return arr
}

export const getEnergyRateTypes = (state) => {
    var arr = new Array()
    arr.push({ text: 'Select One', value: '' })
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.energy_rate_type, function (o) {
        arr.push({ text: o.RateTypeName, value: o.RateTypeID })
    })
    return arr
}

export const getAllEnergyTermLength = (state) => {
    var arr = new Array()
    arr.push({ text: 'Select One', value: '' })
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.term_length, function (o) {
        arr.push({ text: o.TermLengthName, value: o.TermLengthID })
    })
    return arr
}

export const getAllDeliveryTypes = (state) => {
    var arr = new Array()
    arr.push({ text: 'Select One', value: '' })
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.delivery_type, function (o) {
        arr.push({ text: o.deliveryTypeName, value: o.deliveryTypeId })
    })
    return arr
}

export const getAllPostageTypes = (state) => {
    var arr = new Array()
    arr.push({ text: 'Select One', value: '' })
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.postage_type, function (o) {
        arr.push({ text: o.postageName, value: o.postageId })
    })
    return arr
}

export const getAllPreSortedTypes = (state) => {
    var arr = new Array()
    arr.push({ text: 'Select One', value: '' })
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.presorted_type, function (o) {
        arr.push({ text: o.presortedName, value: o.presortedId })
    })
    return arr
}

export const getAllPackageTypes = (state) => {
    var arr = new Array()
    arr.push({ text: 'Select One', value: '' })
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.package_type, function (o) {
        arr.push({ text: o.packageName, value: o.packageTypeId })
    })
    return arr
}

export const getAllApplicationTypes = (state) => {
    var arr = new Array()
    arr.push({ text: 'Select One', value: '' })
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.application_type, function (o) {
        arr.push({ text: o.ApplicationTypeName, value: o.ApplicationTypeID })
    })
    return arr
}

export const getAllCardLevels = (state) => {
    var arr = new Array()
    //arr.push({text:'Select One',value:''})
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.card_level, function (o) {
        arr.push({ text: o.CardLevelTypeName, value: o.CardLevelTypeID })
    })
    return arr
}

export const getAllRewardTypes = (state) => {
    var arr = new Array()
    //arr.push({text:'Select One',value:''})
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.reward_type, function (o) {
        arr.push({ text: o.RewardTypeName, value: o.RewardTypeID })
    })
    return arr
}

export const getProductId = (state) => {
    return state.data.product_id
}

export const getCurrentCompanyImage = (state) => {
    return state.current_company_path
}

export const getProductImg = (state) => {
    return state.data.product_img
}

export const getCurrentCompanyId = (state) => {
    return state.current_company_id
}

export const getCompanyImageData = (state) => {
    return state.company_img_data
}

export const getCompanyAssociatedData = (state) => {
    return state.company_associated_data
}

export const getCurrentImgId = (state) => {
    return state.current_company_id
}

export const getDeliveryMethod = (state) => {
    return state.data.delivery.delivery_method
}

export const getDeliveryType = (state) => {
    return state.data.delivery.delivery_type
}

export const getDeliveryPostage = (state) => {
    return state.data.delivery.postage
}

export const getDeliveryPreSorted = (state) => {
    return state.data.delivery.pre_sorted
}

export const getDeliveryPackageType = (state) => {
    return state.data.delivery.package_type
}

export const getPaymentCardTier1CashAdvanceRegularApr = (state) => {
    return state.data.payment_card.tier_1_cash_advance_regular_apr
}
export const getPaymentCardTier2CashAdvanceRegularApr = (state) => {
    return state.data.payment_card.tier_2_cash_advance_regular_apr
}
export const getPaymentCardTier3CashAdvanceRegularApr = (state) => {
    return state.data.payment_card.tier_3_cash_advance_regular_apr
}
export const getPaymentCardCashAdvanceRegularAprDetails = (state) => {
    return state.data.payment_card.cash_advance_regular_apr_details
}
export const getPaymentCardCashAdvanceRegularRateType = (state) => {
    return state.data.payment_card.cash_advance_regular_rate_type
}

export const getLastWorkedUser = (state) => {
    return state.last_worked_user
}

export const getProductStatus = (state) => {
    return state.data.product_status
}


export const getProductComment = (state) => {
    return state.data.product_comment
}

export const getIsAddProduct = (state) => {
    return state.data.is_addproduct
}

export const getEcContentType = (state) => {
    return state.data.ec_content_type
}

// advertiser

export const getAdvertiserAddress = (state) => {
    return state.data.advertiser.address
}

export const getAdvertiserCity = (state) => {
    return state.data.advertiser.city
}

export const getAdvertiserState = (state) => {
    return state.data.advertiser.state_province
}

export const getAdvertiserZipcode = (state) => {
    return state.data.advertiser.zipcode
}

export const getAdvertiserPhone = (state) => {
    return state.data.advertiser.phone
}

export const getAdvertiserUrl = (state) => {
    return state.data.advertiser.url
}

// advertiser

export const getHoliday = (state) => {
    return state.data.promotion_other_fields.holiday
}

export const getSaleType = (state) => {
    return state.data.promotion_other_fields.sale_type
}

export const getPromotions = (state) => {
    return state.data.promotions
}

export const getAllPromotionTypes = (state) => {
    var arr = [{ text: 'Select One', value: '' }]
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.promotion_type, function (o) {
        arr.push({ text: o.name, value: o.id })
    })
    return arr
}

export const getAllPromotionShippingDetails = (state) => {
    var arr = [{ text: 'Select One', value: '' }]
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.promotion_shpping_details, function (o) {
        arr.push({ text: o.name, value: o.id })
    })
    return arr
}

export const getAllPromotionOnlineInstores = (state) => {
    var arr = [{ text: 'Select One', value: '' }]
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.promotion_online_instores, function (o) {
        arr.push({ text: o.name, value: o.id })
    })
    return arr
}

export const getAllPromotionQualifiers = (state) => {
    var arr = [{ text: 'Select One', value: '' }]
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.promotion_qualifiers, function (o) {
        arr.push({ text: o.name, value: o.id })
    })
    return arr
}

export const getAllPromotionSaleTypes = (state) => {
    var arr = [{ text: 'Select One', value: null }]
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.promotion_sale_types, function (o) {
        arr.push({ text: o.name, value: o.id })
    })
    return arr
}

export const getAllPromotionHolidays = (state) => {
    var arr = [{ text: 'Select One', value: null }]
    if (state.raw_data === '') {
        return arr
    }
    _.forEach(state.raw_data.promotion_holidays, function (o) {
        arr.push({ text: o.name, value: o.id })
    })
    return arr
}

export const getPdfContent = (state) => {
    return state.data.pdf_content
}
export const getCurrentPdf = (state) => {
    return state.data.current_pdf
}
export const getEntryId = (state) => {
    return state.data.entry_id
}

export const getEntryDateChanged = (state) => {
    return state.data.entry_date_changed
}

export const getMobileDigtialFileType = (state) => {
    return state.data.mobile_digital_file_type
}

export const getMobileDigtialFileURL = (state) => {
    return state.data.mobile_digital_file_url
}
export const getMobileDigtialFileSize = (state) => {
    return state.data.mobile_digital_file_size
}
export const getMediaChannelName = (state) => {
    return state.data.medial_channel_name
}

export const getBannerProductPath = (state) => {
    return state.data.banner_product_path
}

export const getDocumentSizeByte = (state) => {
    return state.data.document_size_byte
}

export const getOriginalDocumentSize = (state) => {
    return state.data.original_document_size
}

export const getIsMobileProduct = (state) => {
    return state.data.is_mobile
}

export const getFileName = (state) => {
    return state.data.file_name
}
export const getPDFCDNLINK = (state) => {
    return state.data.pdf_cdn_link
}
export const getPDFCDNLINKORIG = (state) => {
    return state.data.pdf_cdn_link_orig
}
export const getIsDeleted = (state) => {
    return state.data.is_deleted
}
export const getDirectMailLogFile = (state) => {
    return state.data.direct_mail_logfile
}
export const getAddedToDatabase = (state) => {
    return state.data.added_to_database
}



